import { render, staticRenderFns } from "./SummaryPro.vue?vue&type=template&id=35efb1bd&scoped=true&"
import script from "./SummaryPro.vue?vue&type=script&lang=js&"
export * from "./SummaryPro.vue?vue&type=script&lang=js&"
import style0 from "./SummaryPro.vue?vue&type=style&index=0&id=35efb1bd&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35efb1bd",
  null
  
)

export default component.exports